import { Link, useSearchParams } from 'react-router-dom'

const STATUS_TEXT: Record<string, { title: string; desc: string }> = {
  success: {
    title: 'Email güncellendi',
    desc: 'Yeni email adresin aktif. Giriş yapmaya devam edebilirsin.',
  },
  cancelled: {
    title: 'Email değişimi iptal edildi',
    desc: 'İstek iptal edildi. Eski email adresin aktif kalır.',
  },
  expired: {
    title: 'Link süresi dolmuş',
    desc: 'Onay/iptal linki 24 saat geçerli. Yeni bir istek başlat.',
  },
  invalid: {
    title: 'Link geçersiz',
    desc: 'Bu link tanınmıyor veya zaten kullanılmış olabilir.',
  },
}

export default function VerifyEmail() {
  const [params] = useSearchParams()
  const status = params.get('status') || 'invalid'
  const info = STATUS_TEXT[status] || STATUS_TEXT.invalid

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-md text-center space-y-4">
        <h1 className="text-2xl font-semibold">{info.title}</h1>
        <p className="text-[var(--color-text-muted)]">{info.desc}</p>
        <Link to="/dashboard" className="inline-block text-sm hover:underline">
          → Dashboard'a git
        </Link>
      </div>
    </div>
  )
}
